/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest = {
  ledgerCanisterId: string;
};

/** @internal */
export const ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$inboundSchema:
  z.ZodType<
    ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$Outbound =
  {
    ledger_canister_id: string;
  };

/** @internal */
export const ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$outboundSchema:
  z.ZodType<
    ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$Outbound,
    z.ZodTypeDef,
    ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$ {
  /** @deprecated use `ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$inboundSchema;
  /** @deprecated use `ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$outboundSchema;
  /** @deprecated use `ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$Outbound` instead. */
  export type Outbound =
    ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$Outbound;
}

export function listCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequestToJSON(
  listCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest:
    ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest,
): string {
  return JSON.stringify(
    ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$outboundSchema
      .parse(listCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest),
  );
}

export function listCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListCanistersApiV1LedgersLedgerCanisterIdCanistersGetRequest' from JSON`,
  );
}
